"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _TypographyComponent.default;
  }
});

var _TypographyComponent = _interopRequireDefault(require("./Typography-component"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }